/**
 * Created by Ivan on 19.10.2026
 */

(function () {
    const original = MissionsTool.getMissionMenu;

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (mission.type !== Mission.TYPE_DISCO_PARTY) {
            return actions;
        }

        actions.openWindow = displayToolWindow(() => new DiscoPartyWindow(mission));

        actions.winRandomSlot = () => {
            if (mission.logic.isAllWon()) {
                return;
            }

            mission.logic.spin(1);
        };

        actions.reset = () => {
            mission.logic.won = [];
            mission.logic.update(0);
        };

        return actions;
    };
}());
